import { ButtonGroup } from '@material-ui/core';
import React, { Component, Fragment } from 'react';
import { FaEdit, FaSave } from 'react-icons/fa';
import { MdClose, MdPayment } from 'react-icons/md';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { ArcaHttpClientInvoice } from '../../../code/ArcaHttpClientInvoice';
import { ArcaHttpSystem } from '../../../code/ArcaHttpSystem';
import { ArcaSecurity } from '../../../code/ArcaSecurity';
import { ArcaLink } from '../Fields/ArcaLink';
import { InvoiceEditPanel } from './InvoiceEditPanel';

export class InvoiceModalPanel extends Component {

    constructor(props) {
        super(props);

        this.state = {
            wasSettled: false,
            invoice: this.props.invoice,
            isEdit: false
        };
    }

    async onSettleClick(invoiceId) {
        await ArcaHttpClientInvoice.SettleInvoice(
            invoiceId,
            (invoice => this.setState({ invoice, wasSettled: true })),
            (msg => this.setState({ statusText: msg, isError: true }))
        )
    }

    async applyInvoice(invoiceId) {
        await ArcaHttpClientInvoice.ApplyInvoice(
            invoiceId,
            (invoice => this.refreshInvoice(invoiceId)),
            (msg => this.setState({ statusText: msg, isError: true }))
        )
    }

    async refreshInvoice(invoiceId) {
        await ArcaHttpClientInvoice.GetInvoice(
            invoiceId,
            (invoice => this.setState({ invoice })),
            (msg => this.setState({ statusText: msg, isError: true }))
        )
    }

    render() {
        let { invoice, wasSettled, isEdit } = this.state;
        let invoiceRender = <table className='table table-striped' aria-labelledby="tabelLabel">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Description</th>
                    <th>Value</th>
                    {ArcaHttpSystem.VatEnabled
                        ? <th> Vat</th>
                        : null}
                    <th>Total</th>
                </tr>
            </thead>
            <tbody>

                {invoice.Entries?.map((e, k) =>
                    <Fragment key={k}>
                        <tr>
                            <td>{k + 1}</td>
                            <td>{e.Description}<br /> <small>{e.Reason}</small> </td>
                            <td>{invoice.CurrencySymbol + e.Value.toFixed(2)}</td>
                            {ArcaHttpSystem.VatEnabled
                                ? < td > {invoice.CurrencySymbol + e.Vat.toFixed(2)}</td>
                                : null}
                            <td>{invoice.CurrencySymbol + (e.Value + e.Vat).toFixed(2)}</td>
                        </tr>

                    </Fragment>
                )}

            </tbody>
        </table>
        let invoiceEdit = <InvoiceEditPanel
            onCancel={() => this.setState({ isEdit: false })}
            invoice={invoice} />
        let topButtons = <div className='centerText'>
            <ButtonGroup>
                {invoice.StatusCode === 'Invoiced' && ArcaSecurity.IsAdmin
                    ? <ArcaLink text='Settle' icon={<MdPayment />}
                        onClick={this.onSettleClick.bind(this, invoice.Id)} />
                    : null}

                {invoice.StatusCode === 'Created' && ArcaSecurity.IsAdmin
                    ? <ArcaLink text='Apply Invoice' icon={<MdPayment />}
                        onClick={() => this.applyInvoice(invoice.Id)} />
                    : null}

                <ArcaLink text='Close' icon={<MdClose />}
                    onClick={() => this.props.onClose()} />

                {invoice.StatusCode !== 'Paid' && ArcaSecurity.IsAdmin
                    ? <ArcaLink text='Edit Invoice' icon={<FaEdit />}
                        onClick={() => this.setState({ isEdit: true })} />
                    : null}
            </ButtonGroup>
        </div>
        let header = <Fragment>
            <p>Payee: {invoice.InvoiceeName}</p>
            <p>Ref: {invoice.Id}</p>
            <p>Status: {invoice.StatusCode}</p>
            <p>Total: {invoice.CurrencySymbol + invoice.Total.toFixed(2)}</p>
            {ArcaHttpSystem.VatEnabled
                ? <p>Vat: {invoice.CurrencySymbol + invoice.Vat.toFixed(2)}</p>
                : null}

            {wasSettled ? <h4>Invoice has been settled</h4> : null}

            {isEdit ? null : topButtons}
        </Fragment>

        return (
            <Fragment>

                <Modal isOpen={true}>
                    <ModalHeader>
                        <b>Invoice: {invoice.Date.DayAndMonthPretty}</b>

                    </ModalHeader>
                    <ModalBody>

                        <table width='100%'>
                            <thead>
                            </thead>
                            <tbody>
                                <tr>
                                    <td width='50%'>
                                        {isEdit
                                            ? <p>Payee: {invoice.InvoiceeName}</p>
                                            : header}
                                    </td>
                                    <td width='50%'>
                                        <p>  </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        {isEdit
                            ? invoiceEdit
                            : invoiceRender}

                    </ModalBody>
                    <ModalFooter>

                    </ModalFooter>
                </Modal >
            </Fragment >
        );
    }
}